import React from "react";

function SubTaskTeam() {
  return <div></div>;
}

export default SubTaskTeam;
